var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-actions" }, [
    _c("div", { staticClass: "btn-group" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-outline-success",
          attrs: {
            href: "/adm/despesas/relatorio/" + _vm.rowData.id,
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "fas fa-dollar-sign" })]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          attrs: {
            href: "/adm/rotas/diario/relatorio/" + _vm.rowData.id,
            target: "_blank"
          }
        },
        [_c("i", { staticClass: "far fa-calendar-check" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success",
          on: {
            click: function($event) {
              return _vm.getAprova(_vm.rowData.id)
            }
          }
        },
        [_c("i", { staticClass: "far fa-thumbs-up" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info",
          on: {
            click: function($event) {
              return _vm.edite(_vm.rowData.id)
            }
          }
        },
        [_c("i", { staticClass: "fa fa-edit" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-warning",
          on: {
            click: function($event) {
              return _vm.delRota(_vm.rowData.id)
            }
          }
        },
        [_c("i", { staticClass: "far fa-trash-alt" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a754252", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a754252","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/table/RotasActions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3a754252","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/table/RotasActions.vue
// module chunks = 2